import roundLargeNumbers from "./roundLargeNumbers";

export default function formatNumberBasedOnSize(num: number) {
  if(num > 9999) return roundLargeNumbers(num, 2) 
  else if(num > 1) return Number((num).toFixed(2)).toLocaleString('en')
  else return Number((num).toFixed(6)).toLocaleString('en')
}

